function getExtrasProductDataByAjax(data, templateName, callback, numberProductPerAjaxCall, ajaxPage, allAjaxData) {
  if (!ajaxPage) ajaxPage = 0;
  if (!allAjaxData) allAjaxData = [];

  if (!numberProductPerAjaxCall || numberProductPerAjaxCall > 20){
    numberProductPerAjaxCall = 20;
  }
  var fromIndex = numberProductPerAjaxCall * ajaxPage;
  var toIndex = Math.min(data.length, numberProductPerAjaxCall * (ajaxPage + 1));
  var handles = [];
  for (var i = fromIndex; i < toIndex; i++) {
    if (data[i] && data[i].handle) {
      handles.push(encodeURIComponent(data[i].handle));
    }
  }
  var handleString = handles.join("+");
  var path = Utils.buildProductItemUrl({handle:'test'});
  
  if (path.includes('/collections/')) {
    path = path.substring(0, path.indexOf('/collections/'));
  } else if (path.includes('/products/')) {
    path = path.substring(0, path.indexOf('/products/'));
  } else {
    path = '';
  }

  path += '/collections/all';

  var itemDataUrl = path + "/" + handleString + "?view=" + templateName;

  return new Promise((resolve, reject) => {
    jQ.ajax({
      type: "GET",
      url: itemDataUrl,
      dataType: "text",
      success: function(ajaxData) {
        onGetExtrasProductDataByAjaxSuccess(
          data, templateName, callback, numberProductPerAjaxCall, ajaxPage, ajaxData, allAjaxData, resolve, reject
        );
      },
      error: function (error) {
        reject(error);
      },
    });
  });
}

function onGetExtrasProductDataByAjaxSuccess(data, templateName, callback, numberProductPerAjaxCall, ajaxPage, ajaxData, allAjaxData, resolve, reject) {
  try {
    // FIX 4: Prevented JSON.parse crash when Shopify returns a 404 HTML response string instead of JSON
    if (typeof ajaxData === 'string' && ajaxData.trim().startsWith('<')) {
      console.warn('Received HTML response (likely 404) for template: ' + templateName);
    } else {
      if (/<\!--.*?-->/.test(ajaxData)) {
        ajaxData = ajaxData.replace(/<\!--.*?-->/g, '');
      }
      var parsedData = JSON.parse(ajaxData);
      if (parsedData && parsedData.products) {
        allAjaxData = allAjaxData.concat(parsedData.products);
      }
    }
  } catch (error) {
    console.error('Could not parse json from ' + templateName + ": " + error.message);
  }

  var fromIndex = numberProductPerAjaxCall * (ajaxPage + 1);
  if (fromIndex < data.length) {
    ajaxPage++;
    getExtrasProductDataByAjax(data, templateName, callback, numberProductPerAjaxCall, ajaxPage, allAjaxData)
      .then(resolve)
      .catch(reject);
  } else {
    if (typeof callback == 'function') {
      callback(allAjaxData);
    }
    if (resolve) resolve(allAjaxData);
  }
}

if (typeof FilterApi !== 'undefined') {
  FilterApi.afterCallAsync = function(result, callbackFilterApi) {      
    var currency = boostPFSConfig.general.current_currency.toLowerCase();
    if (typeof result.products == 'undefined' || result.products.length === 0) { 
      callbackFilterApi(result);
      return;
    }

    getExtrasProductDataByAjax(result.products, "boost-fix-images")
      .then((productsData) => {
        if (Array.isArray(productsData)) {
          productsData.forEach(function(product) {
            var idx = result.products.findIndex(function(apiProduct) { return apiProduct.id === product.id; });
            if (idx >= 0 && result.products[idx].images_info && product.images) {
              for (var i = 0; i < product.images.length; i++) {
                if (result.products[idx].images_info[i]) {
                  result.products[idx].images_info[i]['src'] = product.images[i];
                }
              }
            } 
          });
        }
        callbackFilterApi(result);
      })
      .catch((error) => {
        console.error(error);
        callbackFilterApi(result);
      });
  };
}

if (typeof InstantSearchApi !== 'undefined') {
  InstantSearchApi.afterCallAsync = function(result, callbackInstantSearchApi) {
    var currency = boostPFSConfig.general.current_currency.toLowerCase();
    
    if (typeof result.products == 'undefined' || result.products.length === 0) {
      callbackInstantSearchApi(result);
      return;
    }

    getExtrasProductDataByAjax(result.products, "boost-fix-images")
      .then((productsData) => {
        if (Array.isArray(productsData)) {
          productsData.forEach(function(product) {
            var idx = result.products.findIndex(function(apiProduct) { return apiProduct.id === product.id; });
            if (idx >= 0 && result.products[idx].images_info && product.images) {
              for (var i = 0; i < product.images.length; i++) {
                if (result.products[idx].images_info[i]) {
                  result.products[idx].images_info[i]['src'] = product.images[i];
                }
              }
            } 
          });
        }
        callbackInstantSearchApi(result);
      })
      .catch((error) => {
        console.error(error);
        // FIX 13: Guaranteed callback execution on failure
        callbackInstantSearchApi(result);
      });
  };
}